import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { Centered } from './NotFound.jsx';

export function Completed() {
  const { token } = useParams();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function handleDownload() {
    setError(null);
    setBusy(true);
    // The signed PDF is rendered asynchronously after signing, so it may 404 for a
    // few seconds. Retry a handful of times before surfacing an error.
    try {
      for (let attempt = 0; attempt < 8; attempt++) {
        const res = await fetch(`/api/m/${token}/pdf`);
        if (res.ok) {
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Fundmerica Application.pdf';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          return;
        }
        if (res.status !== 404) {
          setError('Could not retrieve the PDF. Please try again.');
          return;
        }
        await new Promise((r) => setTimeout(r, 1500));
      }
      setError('Your signed PDF is still being generated. Please try again in a moment.');
    } catch {
      setError('Could not retrieve the PDF. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Centered title="Application submitted">
      <p>Thank you. Your Fundmerica application has been submitted and signed.</p>
      <p>A copy of your signed application will be emailed to you shortly.</p>
      <button onClick={handleDownload} disabled={busy} className="btn-primary mt-4 inline-block">
        {busy ? 'Loading…' : 'Download signed PDF'}
      </button>
      {error && <p className="text-red-600 mt-2 text-sm">{error}</p>}
    </Centered>
  );
}
